export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const TOGGLE_CART_ITEM_AMOUNT = 'TOGGLE_CART_ITEM_AMOUNT';
export const CLEAR_CART = 'CLEAR_CART';
export const COUNT_CART_TOTALS = 'COUNT_CART_TOTALS';
export const UPDATE_SHIPPING_FEE = 'UPDATE_SHIPPING_FEE';

export const GET_USER = 'GET_USER';
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';
